import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_STATUSES,
  FILTER_PARTNER_COMPANIES,
  FILTER_CUSTOMER_COMPANIES,
  FILTER_NETWORKS,
  FILTER_INVOICE_LEVELS,
  FILTER_CURRENCIES,
  FILTER_EXPENSE_TYPES,
  FILTER_OWNERS,
  FILTER_CREATORS,
  FILTERS_DEPENDENCIES as DEPENDENCIES,
} from 'scenes/BusinessPartners/constants';
import * as filtersSource from 'scenes/BusinessPartners/sources/filters';

export const Statuses = (props) => {
  return (
    <Filter.MultiSelect
      title={'Statuses'}
      name={FILTER_STATUSES}
      source={filtersSource.loadStatuses}
      placeholder={'All'}
      {...props}
    />
  );
};

export const PartnerCompanies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Partner Companies'}
      name={FILTER_PARTNER_COMPANIES}
      source={filtersSource.loadPartnerCompanies}
      placeholder={'All'}
      {...props}
    />
  );
};

export const CustomerCompanies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Customer Companies'}
      name={FILTER_CUSTOMER_COMPANIES}
      source={filtersSource.loadCustomerCompanies}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Networks = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks'}
      name={FILTER_NETWORKS}
      source={filtersSource.loadNetworks}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

export const InvoiceLevels = (props) => {
  return (
    <Filter.MultiSelect
      title={'Invoice Levels'}
      name={FILTER_INVOICE_LEVELS}
      source={filtersSource.loadInvoiceLevels}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Currencies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Currencies'}
      name={FILTER_CURRENCIES}
      source={filtersSource.loadCurrencies}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ExpenseTypes = (props) => {
  return (
    <Filter.MultiSelect
      title={'Expense Types'}
      name={FILTER_EXPENSE_TYPES}
      source={filtersSource.loadExpenseTypes}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Owners = (props) => {
  return (
    <UserFilter
      title={'Owners'}
      name={FILTER_OWNERS}
      source={filtersSource.loadOwners}
      withAll={false}
      depends={DEPENDENCIES[FILTER_OWNERS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Creators = (props) => {
  return (
    <UserFilter
      title={'Creators'}
      name={FILTER_CREATORS}
      source={filtersSource.loadCreators}
      depends={DEPENDENCIES[FILTER_CREATORS]}
      placeholder={'All'}
      {...props}
    />
  );
};
